import React, { createContext, useContext, useReducer, useEffect } from "react";
import { mockTransactions } from "../data/mockData";

const AppContext = createContext();

const initialState = {
  transactions: JSON.parse(localStorage.getItem("transactions")) || mockTransactions,
  role: localStorage.getItem("role") || "viewer",
  filters: { search: "", category: "all", type: "all", sort: "date-desc" },
  activeTab: "dashboard",
  theme: "dark",
};

function reducer(state, action) {
  switch (action.type) {
    case "SET_ROLE":
      localStorage.setItem("role", action.payload);
      return { ...state, role: action.payload };
    case "SET_TAB":
      return { ...state, activeTab: action.payload };
    case "SET_FILTER":
      return { ...state, filters: { ...state.filters, ...action.payload } };
    case "ADD_TRANSACTION": {
      const updated = [action.payload, ...state.transactions];
      localStorage.setItem("transactions", JSON.stringify(updated));
      return { ...state, transactions: updated };
    }
    case "EDIT_TRANSACTION": {
      const updated = state.transactions.map((t) =>
        t.id === action.payload.id ? action.payload : t
      );
      localStorage.setItem("transactions", JSON.stringify(updated));
      return { ...state, transactions: updated };
    }
    case "DELETE_TRANSACTION": {
      const updated = state.transactions.filter((t) => t.id !== action.payload);
      localStorage.setItem("transactions", JSON.stringify(updated));
      return { ...state, transactions: updated };
    }
    case "RESET_DATA":
      localStorage.setItem("transactions", JSON.stringify(mockTransactions));
      return { ...state, transactions: mockTransactions };
    default:
      return state;
  }
}

export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <AppContext.Provider value={{ state, dispatch }}>{children}</AppContext.Provider>;
}

export const useApp = () => useContext(AppContext);
